import React, { useState } from "react";
import './OpalPlanningLayout.css';
import PlanningView from "./PlanningView/PlanningView";
import PlanningSidebar from "./PlanningSidebar/PlanningSidebar";
import { addRecord, getNextId } from "../../localDB";

const OpalPlanningLayout = () => {
    // Ensure the default date is set correctly with UTC+8 consideration
    const getTodayWithTimezoneOffset = () => {
        const now = new Date();
        now.setHours(0, 0, 0, 0); // Ensuring time does not affect date selection
        return now;
    };

    const [selectedDate, setSelectedDate] = useState(getTodayWithTimezoneOffset());

    const selectedItem = async (item) => {
        const cpID = localStorage.getItem("c_id");

        const date = selectedDate.toLocaleDateString("en-CA");
        const nextId = await getNextId('session');
        const newSession = {
            ID: nextId,
            AgentID: 102,
            SessionTypeID: 1,
            SessionDate: date,
            CyclePeriodID: Number(cpID),
            InstitutionID: item.InstitutionID,
            AccountID: item.ID,
            RecoverySessionID: null,
            JointCallAgentID: null,
            JointCallRemarks: null,
            AdvancedSessionID: null,
            MissedCallReasonID: null,
            MissedCallRemarks: null,
            ActualStart: null,
            ActualEnd: null,
            ActualLocationLat: null,
            ActualLocationLong: null,
            ActualLocation: null,
            RecipientSignatureFileID: null,
            RecipientPhotoFileID: null,
            Duration: null,
            Status: 0,
            LastUpdatedDate: null,
            SessionItem: []
        };

        try {
            await addRecord('session', newSession);
        } catch (err) {
            console.error("Error saving session:", err);
        }
    }

    const handleDateChange = (date) => {
        setSelectedDate(date);
    
        const sidebar = document.querySelector('.opal-layout-container nav');
        if (sidebar) {
            sidebar.classList.add('show');
        }
    };

    return (
        <div className="opal-layout-container d-flex h-100">
            <div className="flex-grow-1">
                <PlanningView selectedDate={selectedDate} setSelectedDate={handleDateChange} />
            </div>
            <nav id="sidebarMenu" className="col-lg-3 col-xl-3 col-xxl-2 d-lg-block p-0 sidebar-layout">
                <div className="position-sticky">
                    <PlanningSidebar selectedItem={selectedItem} />
                </div>
            </nav>
        </div>
    );
};

export default OpalPlanningLayout;
